import { Crown } from 'lucide-react';
import { useLeadGate } from '@/contexts/LeadGateContext';
import { cn } from '@/lib/utils';

interface PremiumAccessBadgeProps {
  className?: string;
  showOnlyWhenUnlocked?: boolean;
}

/**
 * Premium Access Badge
 * Shows a visual indicator when user has unlocked premium access.
 * Appears in key locations to remind users they have full access.
 */
const PremiumAccessBadge = ({ className, showOnlyWhenUnlocked = true }: PremiumAccessBadgeProps) => {
  const { isUnlocked, contact } = useLeadGate();

  if (showOnlyWhenUnlocked && !isUnlocked) {
    return null;
  }

  const firstName = contact?.name?.split(' ')[0];

  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-semibold',
        'bg-gradient-to-r from-gold/25 to-gold/15',
        'text-gold-light border border-gold/40',
        'shadow-[0_0_12px_rgba(212,175,55,0.3)]',
        'animate-fade-in',
        className
      )}
    >
      <Crown className="w-4 h-4 text-gold" />
      <span className="text-gold-light font-bold tracking-wide">Premium Access</span>
      {firstName && (
        <>
          <span className="text-gold/60">•</span>
          <span className="text-primary-foreground font-semibold">{firstName}</span>
        </>
      )}
    </div>
  );
};

export default PremiumAccessBadge;
